import {
  // m,
  LazyMotion,
  AnimatePresence,
  animate,
  scroll,
  useScroll,
  useSpring,
  useVelocity,
  useInView,
  useReducedMotion,
  useMotionValue,
  useMotionValueEvent,
  MotionValue,
  useTransform,
  useAnimate,
  useAnimationFrame,
  frame,
  cancelFrame,
  useTime,
  cubicBezier,
  animationControls,
  LayoutGroup,
  MotionConfig,
  type Variants,
  type Transition,
} from "motion/react";
// import { useAnimate } from "motion/react-mini";
import * as m from "motion/react-m";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type MotionValuePatch<T> = MotionValue<T> & any;

const useFramerMotion = () => {
  return () =>
    import("@/utils/framerMotionFeatures").then((res) => res.default);
};

export default useFramerMotion;
export {
  LazyMotion,
  m,
  AnimatePresence,
  animate,
  scroll,
  useAnimate,
  useScroll,
  useSpring,
  useVelocity,
  useMotionValue,
  useMotionValueEvent,
  useTransform,
  useAnimationFrame,
  useInView,
  useReducedMotion,
  frame,
  cancelFrame,
  useTime,
  cubicBezier,
  LayoutGroup,
  MotionConfig,
};

export type {
  animationControls,
  MotionValue,
  MotionValuePatch,
  Variants,
  Transition,
};
